// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-j_hh","catalogByServiceItem__title":"c-j_hi"};